import { basicInfoAtom } from "@/atoms";
import { indoorCategoriesAtom, indoorMenuAtom, indoorServiceAtom } from "@/atoms/indoor";
import { recordStorefrontEvent } from "@/domain/storefront-analytics";
import { EmptyState, PageContainer } from "@/components/ui";
import { MenuMode } from "@/lib";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { MenuImageMenu } from "./image-menu";
import { MenuListMenu } from "./list-menu";
import { MenuHeader } from "./menu-header";

/**
 * `/menu` route entry (INDOOR digital menu). Dispatches the same two visual
 * views as delivery (PRODUCT_LIST ↔ ListMenu, CATEGORY_LIST ↔ ImageMenu) from
 * Open Delivery `menuMode`.
 */
export function MenuPage() {
  const basicInfo = useAtomValue(basicInfoAtom);
  const indoorService = useAtomValue(indoorServiceAtom);
  const indoorMenu = useAtomValue(indoorMenuAtom);
  const categories = useAtomValue(indoorCategoriesAtom);

  useEffect(() => {
    if (indoorService && indoorMenu) recordStorefrontEvent({ type: "menu_view" });
  }, [indoorService, indoorMenu]);

  if (!basicInfo) return null;

  if (!indoorService || !indoorMenu) {
    return (
      <>
        <MenuHeader basicInfo={basicInfo} />
        <PageContainer>
          <EmptyState
            size="section"
            className="min-h-empty justify-center"
            title="Cardápio indisponível"
            description="Este estabelecimento ainda não habilitou o cardápio digital."
          />
        </PageContainer>
      </>
    );
  }

  if (indoorMenu.menuMode === MenuMode.CATEGORY_LIST) {
    return <MenuImageMenu basicInfo={basicInfo} categories={categories} />;
  }

  return <MenuListMenu basicInfo={basicInfo} />;
}
